(function(){
var R=document.getElementById('gacb');if(!R)return;var D=R.dataset;

var LABEL  = D.freeLabel;
var HANDLE = 'gelaura-cushion-cover-included';
var CART   = D.cartUrl || '/cart';
var HOME   = D.homeUrl || '';
var GIFTV  = Number(D.giftVid || 0);
var GUARD  = 'ga-cover-sync';
var BE     = document.documentElement.classList.contains('ga-be');

/* ---------- libelle "Offert" sur les lignes a 0 ---------- */
function isZero(txt){
  if (!txt) return false;
  var n = txt.replace(/[^\d.,]/g,'').replace(/\s/g,'');
  if (!n) return false;
  return parseFloat(n.replace(',', '.')) === 0;
}
function tag(row){
  if (row.dataset.gaFree === '1') return;
  row.dataset.gaFree = '1';
  row.classList.add('ga-free');
  var cells = row.querySelectorAll('.cart-item__price-wrapper, .cart-item__totals, .cart-item__discounted-prices, .price');
  cells.forEach(function(c){
    if (c.querySelector('.ga-freetag')) return;
    if (!isZero(c.textContent)) return;
    c.innerHTML = '<span class="ga-freetag">' + LABEL + '</span>';
  });
}
function scan(){
  var rows = document.querySelectorAll('.cart-item, tr.cart-item, .cart-items tr');
  rows.forEach(function(row){
    if (row.querySelector('a[href*="' + HANDLE + '"]')) tag(row);
  });
}

/* ---------- garder le client cote Bien-etre ---------- */
/* Dawn renvoie "Continuer les achats" vers /collections/all, qui est domine  */
/* par le moto. On le reroute vers l'univers Bien-etre.                       */
function retarget(){
  if (!BE || !HOME) return;
  var links = document.querySelectorAll(
    '[id$="__cart-items"] a[href*="/collections/all"], ' +
    '[id$="__cart-footer"] a[href*="/collections/all"], ' +
    '.cart__empty-text a, .cart__warnings a'
  );
  links.forEach(function(a){
    if (a.dataset.gaRt === '1') return;
    a.dataset.gaRt = '1';
    a.setAttribute('href', HOME);
  });
}

/* ---------- combien de housses offertes ce panier merite-t-il ---------- */
/* Deduit du SKU, insensible a la langue et aux titres traduits.          */
function entitled(sku){
  if (!sku) return 0;
  sku = String(sku).toUpperCase();
  if (sku.indexOf('GA-CONF-SEAT-') === 0) {
    var n = parseInt(sku.split('-').pop(), 10);
    return (n > 0) ? n : 1;
  }
  if (sku === 'GA-CONF-DUO')    return 2;
  if (sku === 'GA-CONF-TRIO')   return 3;
  if (sku === 'GA-CONF-COCCYX') return 1;
  return 0;
}

function tries(){
  try { return parseInt(sessionStorage.getItem(GUARD) || '0', 10) || 0; } catch(e){ return 0; }
}
function bump(n){ try { sessionStorage.setItem(GUARD, String(n)); } catch(e){} }
function clear(){ try { sessionStorage.removeItem(GUARD); } catch(e){} }

var busy = false;
function reconcile(){
  if (busy) return;
  busy = true;
  fetch(CART + '.js', { headers: { 'Accept': 'application/json' } })
    .then(function(r){ return r.json(); })
    .then(function(c){
      var due = 0, have = 0, key = null;
      (c.items || []).forEach(function(it){
        if (it.handle === HANDLE) { have += it.quantity; key = it.key; }
        else { due += entitled(it.sku) * it.quantity; }
      });
      if (due === have) { clear(); busy = false; return; }

      /* garde-fou : jamais plus de 2 tentatives, pour ne pas boucler */
      var t = tries();
      if (t >= 2) { busy = false; return; }
      bump(t + 1);

      var url, body;
      if (key) {
        url = '/cart/change.js';
        body = { id: key, quantity: due };
      } else if (due > 0 && GIFTV) {
        url = '/cart/add.js';
        body = { items: [{ id: GIFTV, quantity: due }] };
      } else {
        busy = false; return;
      }
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function(r){
        if (!r.ok) throw new Error('sync');
        window.location.reload();
      });
    })
    .catch(function(){ busy = false; });
}

/* ---------- amorcage ---------- */
var timer = null;
function later(){
  clearTimeout(timer);
  timer = setTimeout(function(){ scan(); retarget(); reconcile(); }, 250);
}

function boot(){
  scan();
  retarget();
  reconcile();
  var host = document.querySelector('cart-items') || document.querySelector('.cart__items') || document.body;
  if (window.MutationObserver) {
    new MutationObserver(later).observe(host, { childList: true, subtree: true });
  }
  document.addEventListener('cart:refresh', later);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();

/* ---------- housse payante en plus ---------- */
var add = document.getElementById('gax-add');
if (add) {
  var qty = document.getElementById('gax-qty');
  function clamp(){
    var n = parseInt(qty.value, 10);
    if (isNaN(n) || n < 1) n = 1;
    if (n > 10) n = 10;
    qty.value = n;
    return n;
  }
  document.getElementById('gax-minus').addEventListener('click', function(){ qty.value = clamp() - 1; clamp(); });
  document.getElementById('gax-plus').addEventListener('click', function(){ qty.value = clamp() + 1; clamp(); });
  qty.addEventListener('change', clamp);
  add.addEventListener('click', function(){
    var n = clamp();
    add.disabled = true;
    fetch(D.addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(add.dataset.vid), quantity: n }] })
    })
    .then(function(r){ if (!r.ok) throw new Error('add'); return r.json(); })
    .then(function(){ window.location.reload(); })
    .catch(function(){ add.disabled = false; });
  });
}
})();
